import cn from 'classnames';

const getInputClasses = props => {
  return cn('peer bg-white text-black text-sm border font-normal not-italic no-underline rounded inline-flex leading-6 px-2 relative w-full text-ellipsis flex items-center', {
    'cursor-not-allowed text-black bg-grey': props.readOnly,
    'border-grey text-opacity-25 cursor-not-allowed': props.disabled,
    'bg-[rgba(255,255,0,0.075)]': props.highlighted && props.disabled,
    'bg-[rgba(255,255,0,0.2)]': props.highlighted && !props.disabled,
    'border-grey-dark hover:shadow-[0_0_0.1rem_theme(colors.grey.darker)] focus:border-blue-light focus:yt-focus active:border-blue-dark': !props.invalid,
    'border-red hover:shadow-[0_0_0.15rem_theme(colors.red.DEFAULT)] focus:border-red-light focus:yt-focus-red active:border-red-dark': props.invalid
  });
};
const getButtonStateClasses = invalid => {
  if (invalid) {
    return '!border-red focus:!border-red-light focus:yt-focus-red peer-focus:!border-red-light peer-focus:peer-active:!border-red-dark';
  }

  return '!border-grey-dark focus:!border-blue-light peer-focus:!border-blue-light peer-focus:peer-active:!border-blue-dark';
};

export { getButtonStateClasses, getInputClasses };
//# sourceMappingURL=util.js.map
